<template>
	<el-select
		style="width:100%"
		v-model="selectTag"
		multiple
		filterable
		allow-create
		default-first-option
		:multiple-limit="limitMax"
		@change="tag_change"
		placeholder="请添加标签">
		<el-option-group
			class="tag_group_custom"
			v-for="group in tag_value"
			:key="group.label"
			:label="group.label">
			<el-option
				v-for="(item ,index) in group.options"
				:key="index"
				:label="item.label"
				:value="item.value">
			</el-option>
		</el-option-group>
	</el-select>
</template>

<script>
	import {fetchTags} from '@/api/bookManage'

	export default {

		name: "muti-select",
		data() {
			return {
				selectTag: this.value,
				tagStore: []
			}
		},
		computed: {
			tag_value() {
				let value = []
				this.tagStore.forEach((item, index) => {
					let arr = []
					item.bookTags.forEach((item2, index) => {
						arr.push({value: item2, label: item2})
					})
					value.push({label: item.name, options: arr})
				})
				return value
			},
		},
		methods: {
			tag_change() {
				this.$emit('input', this.selectTag)
				if (this.$parent.$options.componentName === 'ElFormItem') {
					if (this.validateEvent) {
						this.$parent.$emit('el.form.change', [value])
					}
				}
			},
			getTags() {
				fetchTags().then(res => {
					this.tagStore = res.data.items || []
				})
			}

		},
		props: {
			limitMax: {
				type: Number,
				default: 0
			},
			value: {
				type: Array
			}

		},
		watch: {
			'value': function (newValue) {
				this.selectTag = newValue
			}
		},
		created() {
			this.getTags()

		}


	}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/components/mutiSelect.vue